import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTooltip from "react-tooltip";
import { compose } from 'redux';
import { getFormValues } from "redux-form";

import moment from 'moment';

import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import faArrowLeft from '@fortawesome/fontawesome-pro-light/faArrowLeft';
import faArrowRight from '@fortawesome/fontawesome-pro-light/faArrowRight';

import { DATE_FORMAT, TAB_OCCUPATIONS_DAYS as DAYS } from "../../constants";
import { fetchRoomTypesAvailabilitiesData as fetchData } from "../../store/actions";

import RoomTypeAvailabilities from "./RoomTypeAvailabilities";

class Occupancies extends Component { // TODO přejmenovat?
	static defaultProps = {
		fromDate: null,

		onRoomTypeAvailabilityClick: () => {},
		onFromDateChange: () => {},
	};

	days = [];

	constructor(props) {
		super(props);

		this.state = {
			fromDate: props.fromDate !== null ? moment(props.fromDate) : moment(props.formValues.arrival, DATE_FORMAT),
		};

		this.fetchData();
	}

	initStickyHeader = (el) => {
		if (el) {
			const header = el.querySelector('.occupancies__header');

			const updateHeaderPositionAndStyle = (scrollTop) => {
				header.style.top = Math.max(scrollTop - 11, 0) + 'px';
				header.classList.toggle('stuck', scrollTop > 11);
			};

			window.addEventListener('message', (e) => {
				if (e.data && e.data.type === 'scroll') { // parent scroll
					updateHeaderPositionAndStyle(-(e.data.iframe.top + el.getBoundingClientRect().top));
				}
			});

			window.addEventListener('scroll', () =>
				updateHeaderPositionAndStyle(-el.getBoundingClientRect().top)
			);
		}
	};

	fetchData = (fromDate = null) => {
		if (fromDate === null) {
			fromDate = this.state.fromDate;
		}

		return this.props.dispatch(fetchData(fromDate, moment(fromDate).add(DAYS, 'days')));
	}

	handleNextMonthClick = (e) => {
		e.preventDefault();

		let fromDate = moment(this.state.fromDate).add(DAYS / 2, 'days');

		this.fetchData(fromDate).then(() => {
			this.setState({ fromDate: fromDate });
			this.props.onFromDateChange(moment(fromDate));
		});
	};

	handlePrevMonthClick = (e) => {
		e.preventDefault();

		let fromDate = moment(this.state.fromDate).subtract(DAYS / 2, 'days');
		if (fromDate.isBefore(moment(), 'day')) {
			fromDate = moment();
		}

		this.fetchData(fromDate).then(() => {
			this.setState({ fromDate: fromDate });
			this.props.onFromDateChange(moment(fromDate));
		});
	};

	render() {
		const { isLoading, lang, roomTypesAvailabilities } = this.props;

		const days = [moment(this.state.fromDate).locale(lang)];
		// TODO nevím, proč musíme explicitně nastavovat jazyk, když globálně nastavený je
		days.push();
		[...Array((roomTypesAvailabilities ? roomTypesAvailabilities[Object.keys(roomTypesAvailabilities)[0]].availabilities.length : DAYS) - 1).keys()].forEach((index) =>
			days.push(moment(days[index]).locale(lang).add(1, 'day'))
		);
		this.days = days;

		return (
			<div className="occupancies" ref={(el) => this.initStickyHeader(el)}>
				{isLoading &&
				<div className="fullscreen-loader">
					<div className="loader loader--large"/>
				</div>
				}

				<div className="occupancies__header">
					<div className="occupancies__controls">
						<button className="button" disabled={this.state.fromDate.isSameOrBefore(moment(), 'day')} onClick={e => this.handlePrevMonthClick(e)}>
							<FontAwesomeIcon icon={faArrowLeft} />
						</button>
						<button className="button" onClick={e => this.handleNextMonthClick(e)}>
							<FontAwesomeIcon icon={faArrowRight} />
						</button>
					</div>

					<div className="occupancies__days">
					{days.map((date, index) => (
						<div key={index} className={`occupancies__day ${date.isoWeekday() >= 6 ? 'occupancies__day--weekend' : ''} ${date.date() === 1 ? 'occupancies__day--month-sep' : ''}`}>
							{date.format('D')}.<br />
							<abbr title={date.format('dddd')}>{date.format('dd')}</abbr>
							{date.date() === moment(date).endOf('month').date() &&
							<span className="occupancies__month occupancies__month--end">{date.format('MMMM')}</span>
							}
							{date.date() === 1 &&
							<span className="occupancies__month">{date.format('MMMM Y')}</span>
							}
							{index === 0 && moment(date).endOf('month').date() - date.date() > 24 &&
							<span className="occupancies__month">{date.format('MMMM Y')}</span>
							}
						</div>
					))}
					</div>
				</div>

				<div className="room-types-availabilities">
					{roomTypesAvailabilities && Object.keys(roomTypesAvailabilities).map((roomType) => (
					<RoomTypeAvailabilities key={roomType} days={days} roomType={roomTypesAvailabilities[roomType]} onRoomTypeAvailabilityClick={(day) => this.props.onRoomTypeAvailabilityClick(roomType, moment(this.days[day]))} />
					))}
					{roomTypesAvailabilities &&
					<ReactTooltip
						id="tooltip-occupancies"
						effect="solid"
						type="light"
					/>
					}
					{!roomTypesAvailabilities &&
					<div className="room-type-availabilities">
						<div className="room-type-availabilities__header-container">
							<div className="room-type-availabilities-loader inline-block" style={{ width: '225px' }} />
						</div>
						<div className="room-type-availabilities__day-container">
							<div className="room-type-availabilities-loader room-type-availabilities-loader--taller inline-block" style={{ width: '100%' }} />
						</div>
					</div>
					}
				</div>
			</div>
		)
	}
}

export default compose(
	connect((state) => ({
		formValues: getFormValues('bookingForm')(state),
		isLoading: state.app.isLoading,
		lang: state.app.lang,
		roomTypesAvailabilities: state.app.apiRoomTypesAvailabilitiesResponse,
	})),
)(Occupancies);


// WEBPACK FOOTER //
// ./src/components/Occupancies/index.jsx